/** Common functions shared by most scripts
 * @module app/src/ts/common
 */



// Shortcut to get element by id
const dId = (id: string): HTMLElement | null => {
  return document.getElementById(id);
}


// output to console: 

function logger(s: string): void {;
  console.log('%c' + s, 'background:#DEDEFA;color:#AF9059');
}


/**
 * Modal confirm/alert box:
 * @param msg Message to display
 * @param yes Yes Text
 * @param no No Text
 * @param fn Function to call on close
 * @param arg Parameters to pass to function
 */
const confirm_box = function (msg: string, yes: string, no: string,
  fn: string, arg: string): void {

  const e_box = <HTMLElement>dId("modal_confirm");
  const e_msg = <HTMLElement>dId("modal_message");
  const e_yes = <HTMLInputElement>dId("modal_yes");
  const e_no = <HTMLInputElement>dId("modal_no");

  let confirm_box_status = "wait";


  e_msg.innerHTML = msg;
  e_yes.innerHTML = yes;
  e_no.innerHTML = no;

  e_box.style.display = "flex";

  if (no == "") {

    e_no.style.display = "none";
    e_yes.classList.add("centered");

  } else {

    e_no.style.display = "block";
    e_yes.classList.remove("centered");

  }

  const conf_yes = () => {

    e_yes.removeEventListener("click", conf_yes);
    confirm_box_status = "yes";
    logger("Confirm yes");
    conf_close();

  }


  const conf_no = () => {

    e_no.removeEventListener("click", conf_no);
    confirm_box_status = "no";
    logger("Confirm no");
    conf_close();

  }

  const conf_close = () => {

    e_msg.innerHTML = "";
    e_box.style.display = "none";

    // Call function on window context if present:
    if (fn !== "") {
      (window as any)[fn](arg);
    }

  }
  
  // Add event listeners:
  setTimeout(function () {
    e_yes.addEventListener("click", conf_yes, true);
    e_no.addEventListener("click", conf_no, true);
  }, 750);

};



/**
 * 
 * Error/Confirm show top of screen
 * Does not require user interaction
 * Show for 5 seconds then remove.
 * 
 **/ 
const status_bar = (msg:string, tipo:string) :void => {
	
	logger("status message: " + msg);
	
	let elem = <HTMLElement>dId("modal_status");

	elem.innerHTML = "";
	elem.classList.remove(...elem.classList);
	elem.classList.add("active");

  setTimeout(function(){
    elem.classList.add("status_" + tipo);
		elem.innerHTML = msg;	
	}, 100);

  setTimeout(function(){
    elem.classList.remove("status_" + tipo);
  }, 2000);

  setTimeout(function(){
    elem.classList.remove("active");
  }, 3000);


	
};


export { dId, logger, confirm_box, status_bar };